module.exports = {
    scssVariables: './src/styles/SYNPLAY_ES',
    defaultLanguage: 'es_neutro',
    profileColor: {saturation: 70, brighness: 70},
    favicon: 'sgpfavicon.ico',
    defaultPassword: 'seedcare'
}